// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Colors variables */
.sb-default .sb-wrapper {
  --sb-color: #fff;
  --sb-background: var(--button-color);
  --sb-border-radius: 4px;
  --sb-overflow: hidden;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text {
  --sb-text-padding: 0 1em 0 0;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text .sb-text {
  filter: none;
}

/** Colors variables */
.sb-circles-dark .sb-wrapper, .sb-circles-light .sb-wrapper {
  --sb-color: #fff;
  --sb-background: transparent;
  --sb-min-width: fit-content;
  --sb-height: fit-content;
  --sb-icon-size: 1.4em;
}
.sb-circles-dark .sb-wrapper:active .sb-icon, .sb-circles-light .sb-wrapper:active .sb-icon {
  box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 12px 17px 2px rgba(0, 0, 0, 0.14), 0 5px 22px 4px rgba(0, 0, 0, 0.12);
}
.sb-circles-dark .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-icon {
  background-color: var(--button-color);
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 2.5em;
  min-height: 2.5em;
  border-radius: 50%;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-text, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
  font-size: 0.8em;
  margin-top: 5px;
  border-radius: 1em;
  width: 100%;
  height: 1.8em;
  line-height: 1.8em;
  padding: 0;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-content, .sb-circles-light .sb-wrapper .sb-content {
  align-items: center;
  flex-direction: column;
}

.sb-circles-dark .sb-wrapper .sb-icon {
  background-color: var(--button-color);
}
.sb-circles-dark .sb-wrapper .sb-text {
  color: var(--button-color);
}

.sb-circles-light .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
}
.sb-circles-light .sb-wrapper .sb-icon {
  background: radial-gradient(ellipse farthest-corner at center, white 30%, #f2f2f2 100%);
}

/* You can add global styles to this file, and also import other style files */
body, html {
  height: 100vh;
  margin: 0;
}

body {
  font-family: Arial, sans-serif;
  height: 100vh;
  background-color: #fff; /* Background color for the top half */
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
}

body::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
  background: #fff;
  z-index: -1; /* Ensure the gradient is behind other content */
}

/* Old palette
\$theme-main: #B05995;
\$theme-contrast: #3792BF;
\$theme-1: #282B59;
\$theme-2: #D683DD;
\$theme-3: #27567A;
\$theme-4: #44DDC4;
\$theme-5: #3336AE;
\$theme-6: #18C43D;
*/
.material-symbols-outlined {
  cursor: pointer;
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 48;
}

p {
  font-family: Arial, Helvetica, sans-serif;
  text-align: justify;
  color: #2D2D2A;
}

html, body {
  height: 100%;
}

body {
  margin: 0;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}

.generic-button, .generic-button-alt {
  color: white;
  border-radius: 5px; /* Rounded corners */
  padding: 10px 20px; /* Padding for button size */
  margin-right: 10px;
  cursor: pointer; /* Pointer on hover */
  transition: background-color 0.3s; /* Smooth transition on hover */
}
.generic-button p, .generic-button-alt p {
  color: white;
  margin: 0;
}

.generic-button {
  background-color: #1B3E78; /* Button background color */
  border: 2px solid #1B3E78; /* No border */
}

.generic-button-alt {
  background-color: #0CAD99; /* Button background color */
  border: 2px solid #0CAD99; /* No border */
}

.generic-button:hover {
  background-color: #fff; /* Change color on hover */
  color: #1B3E78;
}
.generic-button:hover p {
  color: #1B3E78;
}

.generic-button-alt:hover {
  background-color: #fff; /* Change color on hover */
  color: #0CAD99;
}
.generic-button-alt:hover p {
  color: #0CAD99;
}

.generic-button:disabled, .generic-button-alt:disabled {
  background-color: #e7e7e7;
  border-color: #e7e7e7;
  cursor: not-allowed;
}

@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.main-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 10px;
  padding-top: 10px;
  margin-left: 3px;
  margin-bottom: 10px;
  border-radius: 10px;
  border: 1px solid rgba(231, 231, 231, 0.5);
  box-shadow: 20px 20px 30px rgba(231, 231, 231, 0.3);
  overflow: hidden;
  position: relative;
}

.span-tool-tip {
  font-size: 12px;
  color: #0CAD99;
  cursor: pointer;
}

.custom-pill {
  color: white;
  background-color: #0CAD99; /* Red background, change to any color */
  border-radius: 20px; /* Makes it pill-shaped */
  padding: 5px 15px; /* Adds padding inside the pill */
  font-weight: bold; /* Optional: Makes the text bold */
  display: inline-block; /* Ensures the pill is inline with text */
}

.loading-spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px; /* Adjust based on your layout */
  color: red;
}

h5 {
  margin: 10px;
}

.chart-container {
  margin-top: 0px;
  margin-bottom: 5px;
  height: -moz-fit-content;
  height: fit-content;
  width: 100%;
  display: flex;
  z-index: 1;
  flex-direction: column;
  position: relative;
  padding: 0 10px 0 0;
}

.card-bottom {
  margin-top: 3px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-bottom-right {
  display: flex;
  flex-direction: row;
  padding: 0 5px 0 5px;
  position: relative;
}
.card-bottom-right .material-symbols-outlined {
  padding: 0 0 0 10px;
}
.card-bottom-right .material-icons {
  padding: 0 0 0 10px;
}

.card-bottom-left {
  display: flex;
  flex-direction: row;
  padding: 0 5px 0 5px;
}
.card-bottom-left .rounded-button-filled, .card-bottom-left .rounded-button-inverse {
  padding: 5px 10px;
}

.material-symbols-outlined:hover, .material-icons:hover {
  color: #0CAD99;
  transition: color 0.1s ease-in-out, background-color 0.5s ease-in-out;
}

.material-symbols-outlined:active, .material-icons:active {
  color: #AACCFF;
}

p {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  text-align: justify;
  color: #2D2D2A;
  margin-left: 5px;
  margin-right: 5px;
}

.copyright {
  width: 100px;
  display: flex;
  align-self: flex-end;
  margin-bottom: 5px;
  margin-right: 10px;
}

.download-overlay {
  display: none;
  flex-direction: column;
  position: absolute;
  text-align: center;
  justify-content: center;
  align-items: center;
  z-index: 99;
  border-radius: 5px;
  width: 100%;
  height: 100%;
  background-color: rgba(224, 224, 224, 0.5);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}
.download-overlay .card {
  height: 60%;
  width: 60%;
  border-radius: 5px;
  border: 2px solid;
  animation: borderAnimation 7s infinite;
  background-color: white;
  display: flex;
  flex-direction: column;
  position: absolute;
  text-align: center;
  justify-content: center;
  align-items: center;
}
@keyframes borderAnimation {
  0% {
    border-color: #1B3E78;
  }
  0% {
    box-shadow: inset 0px 0px 3px 1px #1B3E78;
  }
  50% {
    border-color: #0CAD99;
  }
  50% {
    box-shadow: inset 0px 0px 3px 1px #0CAD99;
  }
  100% {
    border-color: #1B3E78;
  }
  100% {
    box-shadow: inset 0px 0px 3px 1px #1B3E78;
  }
}
.download-overlay .card p {
  color: #1B3E78;
  font-family: "Dm Sans", sans-serif;
  font-weight: bold;
}
.download-overlay .card img {
  max-height: 75%;
  max-width: 200px;
}

.download-dialog-overlay {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 98;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(224, 224, 224, 0.5);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.download-dialog {
  width: 425px;
  max-width: 90vw;
  height: 450px;
  padding: 5px 30px 5px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  border-radius: 30px;
  border: 1px solid rgba(231, 231, 231, 0.5);
  box-shadow: 20px 20px 30px rgba(231, 231, 231, 0.5);
}
.download-dialog .download-header {
  width: 100%;
  height: 10%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.download-dialog .center-content {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  width: 100%;
}
.download-dialog .download-header p {
  font-weight: bold;
  font-size: 20px;
  margin: 0;
}
.download-dialog #embed-instead {
  margin-left: auto;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
.download-dialog #embed-instead p {
  font-weight: normal;
  font-size: 11px;
  text-decoration: underline;
  cursor: pointer;
  margin: 0;
}
.download-dialog #embed-instead p:hover {
  color: #0CAD99;
}
.download-dialog .download-header > div:first-child {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.download-dialog .download-body {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.download-dialog .download-body p {
  margin-top: 5px;
}
.download-dialog .download-body textarea {
  border-radius: 5px;
}
.download-dialog .download-body .download-body-top {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.download-dialog .download-body .download-body-top .radio-selector-container, .download-dialog .download-body .download-body-top .radio-selector-container-no-border {
  width: 100vw;
}
.download-dialog .download-body .download-body-top .share-instead {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 10px;
  padding: 5px;
  background-color: #1B3E78;
  color: white;
  transition: all 1s;
  width: 120px;
  height: 80px;
  margin-right: 50px;
}
.download-dialog .download-body .download-body-top .share-instead span {
  font-size: 25px;
}
.download-dialog .download-body .download-body-top .share-instead span p {
  color: white;
  font-size: 16px;
  text-align: center;
  font-weight: 400;
}
.download-dialog .download-body .download-body-top .share-instead div {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.download-dialog .download-body .download-body-top .share-instead:hover {
  background-color: #0CAD99;
}
.download-dialog .download-body .download-body-top .share-instead:hover span {
  color: white;
}
.download-dialog .download-body .download-body-top .material-symbols-outlined {
  font-size: 50px;
}
.download-dialog .download-body .radio-selector-container {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  border: 1px solid rgba(231, 231, 231, 0.3);
  height: -moz-fit-content;
  height: fit-content;
  padding: 0 0 10px 0;
  border-radius: 5px;
}
.download-dialog .download-body .radio-selector-container p {
  margin: 0 0 10 0;
  font-size: 13pt;
}
.download-dialog .download-body .radio-selector-container .radioinput {
  accent-color: #1B3E78;
  margin-bottom: 5px;
}
.download-dialog .download-body .radio-selector-container label {
  font-size: 11pt;
}
.download-dialog .download-body .radio-selector-container-no-border {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: -moz-fit-content;
  height: fit-content;
  padding: 10px 0 10px 0;
  border-radius: 5px;
}
.download-dialog .download-body .radio-selector-container-no-border p {
  margin: 0 0 10 0;
  font-size: 13pt;
}
.download-dialog .download-body .radio-selector-container-no-border .radioinput {
  accent-color: #1B3E78;
  margin-bottom: 5px;
}
.download-dialog .download-body .radio-selector-container-no-border label {
  font-size: 11pt;
}
.download-dialog .download-body .custom-selectors-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid rgba(231, 231, 231, 0.3);
  height: -moz-fit-content;
  height: fit-content;
  padding: 10px 10% 10px 10%;
  border-radius: 5px;
}
.download-dialog .download-body .custom-selectors-container div {
  margin: inherit;
  display: flex;
  justify-content: space-between;
}
.download-dialog .download-body .custom-selectors-container div select {
  width: 158px;
  background-color: white;
  border: 1px solid #8f8f9d;
  font-family: Arial, Helvetica, sans-serif;
  text-align: center;
}
.download-dialog .download-body .result-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.download-dialog .download-footer {
  width: 100%;
  height: 10%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px;
}
.download-dialog .download-footer span {
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  padding: 5px 10px 5px 10px;
  background-color: #1B3E78;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  cursor: pointer;
}
.download-dialog .download-footer span p {
  font-size: 12pt;
  margin: 0;
  color: white;
}
.download-dialog .download-footer span.disabled {
  background-color: gray;
  cursor: not-allowed;
  opacity: 0.6;
  pointer-events: none;
}
.download-dialog .download-footer div :hover {
  background-color: #0CAD99;
}
.download-dialog mat-tab {
  margin-top: 50px;
}

.plot {
  height: 500px;
  overflow: hidden;
}

.dialog {
  display: none;
  z-index: 5;
  position: absolute;
  height: 75vh;
  width: 100%;
  max-width: 80vw;
}

app-chart-share-dialog {
  width: 100vw;
}

.rounded-button-filled {
  background-color: #0CAD99; /* Button background color */
  color: white; /* Text color */
  border: 2px solid #0CAD99; /* No border */
  border-radius: 5px; /* Rounded corners */
  padding: 10px 20px; /* Padding for button size */
  margin-left: 10px; /* Spacing between buttons */
  margin-bottom: 30px; /* Bottom margin */
  cursor: pointer; /* Pointer on hover */
  transition: background-color 0.3s; /* Smooth transition on hover */
}

.rounded-button-filled:hover {
  background-color: #fff; /* Change color on hover */
  color: #0CAD99;
}

.rounded-button-inverse {
  background-color: #fff; /* Transparent background */
  color: #1B3E78; /* Text color matching filled button */
  border: 2px solid #0CAD99; /* Pink border */
  border-radius: 5px; /* Rounded corners */
  padding: 10px 20px; /* Padding for button size */
  margin-left: 10px; /* Spacing between buttons */
  cursor: pointer; /* Pointer on hover */
  transition: background-color 0.3s, color 0.3s; /* Smooth transition on hover */
}

.rounded-button-inverse:hover {
  background-color: #0CAD99; /* Background color on hover */
  color: white; /* Text color on hover */
}

.error-message {
  color: red;
}

.filter-list-input {
  margin-top: 15px;
  width: 95%;
}

.lock {
  font-size: 12px;
}

a {
  width: 100%;
  height: 100%;
  color: #1B3E78;
  text-decoration: none;
  display: flex;
}

.buttons-disabled {
  color: #9E9E9E;
}

.padlock-container {
  display: flex;
}

@media (max-width: 767px) {
  ::ng-deep .mat-mdc-tab .mdc-tab__content {
    font-size: 9pt; /* Set your desired font size here */
  }
  .download-dialog {
    width: 300px;
  }
  .download-dialog .download-header p {
    font-size: 18px;
  }
  .chart-container {
    min-width: 80vw;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/ngx-sharebuttons/themes/variables.scss","webpack://./node_modules/ngx-sharebuttons/themes/default.scss","webpack://./src/app/shared/toolbox/charts/chart-wrapper/chart-wrapper.component.scss","webpack://./node_modules/ngx-sharebuttons/themes/circles.scss","webpack://./src/styles.scss","webpack://./src/theme/fonts.scss","webpack://./src/theme/variables.scss"],"names":[],"mappings":"AAAA,sBAAA;ACEA;EACE,gBAAA;EACA,oCAAA;EACA,uBAAA;EACA,qBAAA;ACAF;ADEE;EACE,4BAAA;ACAJ;ADEI;EACE,YAAA;ACAN;;AFZA,sBAAA;AGME;EACE,gBAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,qBAAA;ADUJ;ACPM;EACE,sHAAA;ADSR;ACLI;EACE,qCAAA;EACA,iHAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,2GAAA;ADON;ACJI;EACE,0BAAA;EACA,gBA3BS;EA4BT,eAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,2GAAA;ADMN;ACHI;EACE,mBAAA;EACA,sBAAA;ADKN;;ACEE;EACE,qCAAA;ADCJ;ACEE;EACE,0BAAA;ADAJ;;ACME;EACE,0BAAA;ADHJ;ACME;EACE,uFAAA;ADJJ;;AEzDA,8EAAA;AAEA;EACA,aAAA;EAEA,SAAA;AF0DA;;AEvDA;EACI,8BAAA;EACA,aAAA;EACA,sBAAA,EAAA,sCAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;AF0DJ;;AEtDA;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EAGA,WAAA,EAAA,gDAAA;AFuDJ;;AElDA;;;;;;;;;CAAA;AA0CA;EAEI,eAAA;EACA,kEACI;AFmBR;;AEbA;EACI,yCAAA;EACA,mBAAA;EACA,cAxDS;AFwEb;;AEXA;EAAa,YAAA;AFeb;;AEdA;EAAO,SAAA;EAAW,iDAAA;AFmBlB;;AEhBA;EACE,YAAA;EACA,kBAAA,EAAA,oBAAA;EACE,kBAAA,EAAA,4BAAA;EACA,kBAAA;EAGA,eAAA,EAAA,qBAAA;EACA,iCAAA,EAAA,+BAAA;AFiBJ;AEfI;EACI,YAAA;EACA,SAAA;AFiBR;;AEdA;EACE,yBArEW,EAqEoB,4BAAA;EAC/B,yBAAA,EAAA,cAAA;AFiBF;;AEdA;EACE,yBA7Da,EA6DoB,4BAAA;EACjC,yBAAA,EAAA,cAAA;AFiBF;;AEdA;EACI,sBAAA,EAAA,0BAAA;EACA,cAhFS;AFiGb;AEfI;EACI,cAnFK;AFoGb;;AEbA;EACE,sBAAA,EAAA,0BAAA;EACA,cA5Ea;AF4Ff;AEdE;EACE,cA/EW;AF+Ff;;AEZA;EACI,yBA/Ec;EAgFd,qBAhFc;EAiFd,mBAAA;AFeJ;;AGnKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AHsKF;AGnKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;AHqKF;AGlKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AHoKF;AGjKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;AHmKF;AGhKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AHkKF;AG/JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;AHiKF;AG9JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AHgKF;AG7JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AH+JF;AG5JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AH8JF;AG3JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AH6JF;AG1JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;AH4JF;AGzJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AH2JF;AGxJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;AH0JF;AGvJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;AHyJF;AGtJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AHwJF;AGrJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AHuJF;AGpJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;AHsJF;AGnJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AHqJF;AIzQA;;;;;uBAAA;AJJA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EAIA,oBAAA;EACA,iBAAA;EAEA,gBAAA;EAGA,mBAAA;EACA,mBAAA;EAEA,0CAAA;EACA,mDAAA;EACA,gBAAA;EAGA,kBAAA;AA4QJ;;AAzQA;EACE,eAAA;EACA,cIRe;EJSf,eAAA;AA4QF;;AAzQA;EACE,YAAA;EACA,yBIde,EJcqB,wCAAA;EACpC,mBAAA,EAAA,yBAAA;EACA,iBAAA,EAAA,iCAAA;EACA,iBAAA,EAAA,kCAAA;EACA,qBAAA,EAAA,yCAAA;AA4QF;;AAzQA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA,EAAA,gCAAA;EACA,UAAA;AA4QF;;AAzQA;EACI,YAAA;AA4QJ;;AA1QA;EACI,eAAA;EACA,kBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;AA6QJ;;AA1QA;EAEI,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AA4QJ;;AAxQA;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;AA2QJ;AAzQI;EACI,mBAAA;AA2QR;AAzQI;EACI,mBAAA;AA2QR;;AAtQA;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;AAyQJ;AAvQI;EACK,iBAAA;AAyQT;;AArQA;EACI,cI/Ea;EJgFb,qEAAA;AAwQJ;;AArQA;EAEI,cInFM;AJ0VV;;AAnQA;EACI,yCAAA;EACA,eAAA;EACA,mBAAA;EACA,cE7ES;EF8ET,gBAAA;EACA,iBAAA;AAsQJ;;AAnQA;EACI,YAAA;EACA,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;AAsQJ;;AAlQA;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EAGA,WAAA;EACA,kBAAA;EAEA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,0BAAA;EACA,kCAAA;AAkQJ;AA7PI;EAEI,WAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,sCAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AA8PR;AA5PQ;EACI;IAAK,qBIjJJ;EJgZX;EA9PU;IAAI,yCAAA;EAiQd;EA/PU;IAAM,qBInJD;EJqZf;EAjQU;IAAK,yCAAA;EAoQf;EAlQU;IAAM,qBIvJL;EJ4ZX;EApQU;IAAO,yCAAA;EAuQjB;AACF;AArQU;EACE,cIjKA;EJkKA,kCI5KE;EJ6KF,iBAAA;AAuQZ;AApQU;EACE,eAAA;EACA,gBAAA;AAsQZ;;AA7PA;EAGI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,0BAAA;EACA,kCAAA;AA8PJ;;AA3PA;EACI,YAAA;EACA,eAAA;EACA,aAAA;EACA,0BAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EAEA,uBAAA;EACA,mBAAA;EACA,0CAAA;EACA,mDAAA;AA4PJ;AA1PI;EACI,WAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AA4PR;AAzPI;EACI,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AA2PR;AAxPI;EACI,iBAAA;EACA,eAAA;EACA,SAAA;AA0PR;AAvPI;EACI,iBAAA;EACA,aAAA;EACA,qBAAA;EACA,yBAAA;AAyPR;AAtPI;EACI,mBAAA;EACA,eAAA;EACA,0BAAA;EACA,eAAA;EACA,SAAA;AAwPR;AArPI;EACI,cIrPS;AJ4ejB;AAlPI;EACI,kBAAA;EACA,SAAA;EACA,2BAAA;AAoPR;AAjPI;EACI,WAAA;EACA,YAAA;EAEA,gBAAA;EACA,aAAA;EACA,sBAAA;AAkPR;AAjPQ;EACI,eAAA;AAmPZ;AAjPQ;EACI,kBAAA;AAmPZ;AA/OQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAiPZ;AAhPY;EACI,YAAA;AAkPhB;AAhPY;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBIjSH;EJkSG,YAAA;EAEA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AAiPhB;AA5OgB;EACI,eAAA;AA8OpB;AA7OoB;EACI,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AA+OxB;AA1OgB;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AA4OpB;AAxOa;EACG,yBI9TC;AJwiBjB;AAxOgB;EACI,YAAA;AA0OpB;AAtOY;EACI,eAAA;AAwOhB;AApOO;EAKC,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,0CAAA;EAEA,wBAAA;EAAA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAiOR;AA5OQ;EACI,gBAAA;EACA,eAAA;AA8OZ;AAnOY;EACI,qBI1VH;EJ2VG,kBAAA;AAqOhB;AAlOY;EACI,eAAA;AAoOhB;AA/NQ;EAKA,aAAA;EACA,sBAAA;EACA,6BAAA;EAEA,wBAAA;EAAA,mBAAA;EACA,sBAAA;EACA,kBAAA;AA4NR;AAtOQ;EACI,gBAAA;EACA,eAAA;AAwOZ;AA9NY;EACI,qBIlXH;EJmXG,kBAAA;AAgOhB;AA7NY;EACI,eAAA;AA+NhB;AA1NO;EACC,aAAA;EACA,sBAAA;EACA,8BAAA;EAEA,0CAAA;EAEA,wBAAA;EAAA,mBAAA;EACA,0BAAA;EACA,kBAAA;AA0NR;AAxNY;EACI,eAAA;EACA,aAAA;EAEA,8BAAA;AAyNhB;AAvNgB;EACI,YAAA;EACA,uBAAA;EACA,yBAAA;EAEA,yCAAA;EACA,kBAAA;AAwNpB;AAhNO;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;AAkNR;AA5MI;EACI,WAAA;EACA,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;AA6MR;AA5MQ;EACI,uBAAA;EAAA,kBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,0BAAA;EACA,yBIhbC;EJkbD,mBAAA;EACA,aAAA;EACA,uBAAA;EAEA,eAAA;AA4MZ;AA1MY;EACI,eAAA;EACA,SAAA;EACA,YAAA;AA4MhB;AA1MY;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;AA4MZ;AAxMQ;EACI,yBIrcK;AJ+oBjB;AAtMI;EACI,gBAAA;AAwMR;;AAnMA;EACI,aAAA;EACA,gBAAA;AAsMJ;;AAnMA;EACI,aAAA;EAGA,UAAA;EAGA,kBAAA;EACA,YAAA;EAEA,WAAA;EACA,eAAA;AAiMJ;;AA3LA;EACI,YAAA;AA8LJ;;AA3LA;EACI,yBEjcW,EFicsB,4BAAA;EACjC,YAAA,EAAA,eAAA;EACA,yBAAA,EAAA,cAAA;EACA,kBAAA,EAAA,oBAAA;EACA,kBAAA,EAAA,4BAAA;EACA,iBAAA,EAAA,4BAAA;EACA,mBAAA,EAAA,kBAAA;EAEA,eAAA,EAAA,qBAAA;EACA,iCAAA,EAAA,+BAAA;AA6LJ;;AA1LA;EACI,sBAAA,EAAA,0BAAA;EACA,cE/cW;AF4oBf;;AA1LA;EACI,sBAAA,EAAA,2BAAA;EACA,cI9fS,EJ8f6B,sCAAA;EACtC,yBAAA,EAAA,gBAAA;EACA,kBAAA,EAAA,oBAAA;EACA,kBAAA,EAAA,4BAAA;EACA,iBAAA,EAAA,4BAAA;EAEA,eAAA,EAAA,qBAAA;EACA,6CAAA,EAAA,+BAAA;AA4LJ;;AAzLA;EACI,yBE/dW,EF+d4B,8BAAA;EACvC,YAAA,EAAA,wBAAA;AA4LJ;;AAzLA;EACI,UAAA;AA4LJ;;AAxLA;EACI,gBAAA;EACA,UAAA;AA2LJ;;AArLA;EACG,eAAA;AAwLH;;AAnLC;EACG,WAAA;EACA,YAAA;EACA,cIniBS;EJoiBT,qBAAA;EACA,aAAA;AAsLJ;;AAnLA;EACI,cErfU;AF2qBd;;AAnLA;EACI,aAAA;AAsLJ;;AAnLA;EACI;IACA,cAAA,EAAA,oCAAA;EAsLF;EAnLE;IACI,YAAA;EAqLN;EAnLM;IACI,eAAA;EAqLV;EAhLE;IACI,eAAA;EAkLN;AACF","sourcesContent":["/** Colors variables */\r\n\r\n$sb-primary: #2E4057 !default;\r\n$sb-accent: #fff !default;\r\n$sb-facebook: #4267B2 !default;\r\n$sb-twitter: #00acee !default;\r\n$sb-google: #db4437 !default;\r\n$sb-mix: #ff8226 !default;\r\n$sb-linkedin: #006fa6 !default;\r\n$sb-pinterest: #bd081c !default;\r\n$sb-reddit: #ff4006 !default;\r\n$sb-tumblr: #36465d !default;\r\n$sb-whatsapp: #25d366 !default;\r\n$sb-messenger: #0080FF !default;\r\n$sb-telegram: #0088cc !default;\r\n$sb-xing: #006567 !default;\r\n$sb-email: #FF961C !default;\r\n$sb-viber: #665ca7 !default;\r\n$sb-vk: #4C75A3 !default;\r\n$sb-copy: #607D8B !default;\r\n$sb-print: #765AA2 !default;\r\n$sb-sms: #20c16c !default;\r\n$sb-gray: #a5a5a5 !default;\r\n$sb-expand: #FF6651 !default;\r\n$sb-line: #00b900 !default;\r\n\r\n$sb-buttons: (\r\n  facebook: $sb-facebook,\r\n  twitter: $sb-twitter,\r\n  google: $sb-google,\r\n  mix: $sb-mix,\r\n  line: $sb-line,\r\n  linkedin: $sb-linkedin,\r\n  pinterest: $sb-pinterest,\r\n  reddit: $sb-reddit,\r\n  tumblr: $sb-tumblr,\r\n  whatsapp: $sb-whatsapp,\r\n  messenger: $sb-messenger,\r\n  telegram: $sb-telegram,\r\n  xing: $sb-xing,\r\n  sms: $sb-sms,\r\n  email: $sb-email,\r\n  viber: $sb-viber,\r\n  vk: $sb-vk,\r\n  copy: $sb-copy,\r\n  print: $sb-print,\r\n  expand: $sb-expand\r\n) !default;\r\n","@import \"variables\";\r\n\r\n.sb-default .sb-wrapper {\r\n  --sb-color: #{$sb-accent};\r\n  --sb-background: var(--button-color);\r\n  --sb-border-radius: 4px;\r\n  --sb-overflow: hidden;\r\n\r\n  &.sb-show-icon.sb-show-text {\r\n    --sb-text-padding: 0 1em 0 0;\r\n\r\n    .sb-text {\r\n      filter: none;\r\n    }\r\n  }\r\n}\r\n","@import '../../../../../styles.scss';\n@import 'variables';\n\n.main-container {\n    display: flex;\n    flex-direction:column;\n    justify-content:center;\n    //border: 1px solid $theme-back;\n\n    //padding:10px;\n    padding-bottom:10px;\n    padding-top: 10px;\n    //height:500px;\n    margin-left:3px;\n\n\n    margin-bottom:10px;\n    border-radius: 10px;\n    //background: #e0e0e0;\n    border: 1px solid rgba($theme-lightgray,0.5);\n    box-shadow: 20px 20px 30px rgba($theme-lightgray, 0.3);\n    overflow:hidden;\n    //height:500px;\n    //width:100%;\n    position:relative;\n\n}\n.span-tool-tip{\n  font-size: 12px;\n  color: $theme-contrast;\n  cursor: pointer;\n}\n\n.custom-pill {\n  color: white;\n  background-color: $theme-contrast;  /* Red background, change to any color */\n  border-radius: 20px;  /* Makes it pill-shaped */\n  padding: 5px 15px;  /* Adds padding inside the pill */\n  font-weight: bold;  /* Optional: Makes the text bold */\n  display: inline-block;  /* Ensures the pill is inline with text */\n}\n\n.loading-spinner-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100px; /* Adjust based on your layout */\n  color: red;\n}\n\nh5{\n    margin: 10px;\n}\n.chart-container {\n    margin-top:0px;\n    margin-bottom: 5px;\n    height: fit-content;\n    width:100%;\n    display:flex;\n    z-index: 1;\n    flex-direction:column;\n    position:relative;\n    padding:0 10px 0 0;\n}\n\n.card-bottom {\n    //border: 1px solid $theme-back;\n    margin-top: 3px;\n    display:flex;\n    justify-content: space-between;\n    align-items: center;\n\n}\n\n.card-bottom-right {\n    display:flex;\n    flex-direction: row;\n    padding:0 5px 0 5px;\n    position:relative;\n\n    .material-symbols-outlined {\n        padding:0 0 0 10px;\n    }\n    .material-icons {\n        padding:0 0 0 10px;\n\n    }\n}\n\n.card-bottom-left {\n    display:flex;\n    flex-direction: row;\n    padding:0 5px 0 5px;\n\n    .rounded-button-filled, .rounded-button-inverse {\n         padding: 5px 10px;\n    }\n}\n\n.material-symbols-outlined:hover, .material-icons:hover {\n    color: $theme-contrast;\n    transition: color 0.1s ease-in-out, background-color 0.5s ease-in-out;\n}\n\n.material-symbols-outlined:active, .material-icons:active {\n    // background-color: $theme-1;\n    color: $theme-2;\n\n}\n\np {\n    font-family:Arial, Helvetica, sans-serif;\n    font-size:12px;\n    text-align: justify;\n    color: $theme-back;\n    margin-left:5px;\n    margin-right:5px;\n}\n\n.copyright {\n    width:100px;\n    display:flex;\n    align-self:flex-end;\n    margin-bottom:5px;\n    margin-right:10px;\n}\n\n\n.download-overlay {\n    display:none;\n    flex-direction:column;\n    position:absolute;\n    text-align:center;\n    justify-content: center;\n    align-items: center;\n    //width:600px;\n    //height: 500px;\n    z-index: 99;\n    border-radius: 5px;\n    //margin: 2.5% 2.5% 2.5% 2.5%;\n    width:100%;\n    height:100%;\n    background-color: rgba(#e0e0e0, 0.5);\n    backdrop-filter: blur( 4px );\n    -webkit-backdrop-filter: blur( 4px );\n\n\n\n\n    .card {\n\n        height: 60%;\n        width: 60%;\n        border-radius: 5px;\n        border: 2px solid;\n        animation: borderAnimation 7s infinite;\n        background-color: white;\n        display:flex;\n        flex-direction:column;\n        position:absolute;\n        text-align:center;\n        justify-content: center;\n        align-items: center;\n\n        @keyframes borderAnimation {\n            0% { border-color: $theme-main; }\n            0% {box-shadow: inset 0px 0px 3px 1px $theme-main;}\n\n            50% { border-color: $theme-contrast; }\n            50% {box-shadow: inset 0px 0px 3px 1px $theme-contrast;}\n\n            100% {border-color: $theme-main;}\n            100% { box-shadow: inset 0px 0px 3px 1px $theme-main; }\n          }\n\n          p {\n            color:$dark-text;\n            font-family:$font-family;\n            font-weight:bold;\n          }\n\n          img {\n            max-height:75%;\n            max-width:200px;\n          }\n\n\n    }\n\n\n}\n\n.download-dialog-overlay {\n\n\n    position:absolute;\n    top:0;\n    left:0;\n    height:100%;\n    width:100%;\n    z-index:98;\n    display:flex;\n    flex-direction: column;\n    align-items:center;\n    justify-content: center;\n    background-color: rgba(#e0e0e0, 0.5);\n    backdrop-filter: blur( 4px );\n    -webkit-backdrop-filter: blur( 4px );\n}\n\n.download-dialog {\n    width:425px;\n    max-width: 90vw;\n    height:450px;\n    padding:5px 30px 5px 30px;\n\n    display:flex;\n    flex-direction: column;\n    align-items:center;\n    justify-content:space-between;\n\n    background-color: white;\n    border-radius: 30px;\n    border: 1px solid rgba($theme-lightgray,0.5);\n    box-shadow: 20px 20px 30px rgba($theme-lightgray, 0.5);\n\n    .download-header {\n        width: 100%;\n        height: 10%;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        position: relative;\n    }\n\n    .center-content {\n        position: absolute;\n        left: 50%;\n        transform: translateX(-50%);\n        display: flex;\n        justify-content: center;\n        width: 100%;\n    }\n\n    .download-header p {\n        font-weight: bold;\n        font-size: 20px;\n        margin: 0;\n    }\n\n    #embed-instead {\n        margin-left: auto;\n        display:flex;\n        align-items: flex-end;\n        justify-content: flex-end;\n    }\n\n    #embed-instead p {\n        font-weight: normal;\n        font-size: 11px;\n        text-decoration: underline;\n        cursor: pointer;\n        margin: 0;\n    }\n\n    #embed-instead p:hover {\n        color:$theme-contrast;\n    }\n\n\n\n    .download-header > div:first-child {\n        position: absolute;\n        left: 50%;\n        transform: translateX(-50%);\n    }\n\n    .download-body {\n        width:100%;\n        height:100%;\n        //max-height: 80%;\n        overflow-y: auto;\n        display:flex;\n        flex-direction: column;\n        p {\n            margin-top:5px;\n        }\n        textarea {\n            border-radius: 5px;\n\n        }\n\n        .download-body-top {\n            width: 100%;\n            display:flex;\n            flex-direction:row;\n            justify-content: space-between;\n            align-items: center;\n            .radio-selector-container, .radio-selector-container-no-border {\n                width:100vw;\n            }\n            .share-instead {\n                display:flex;\n                flex-direction: column;\n                align-items: center;\n                justify-content: center;\n                text-align: center;\n                border-radius: 10px;\n                padding:5px;\n                background-color: $theme-main;\n                color: white;\n\n                transition: all 1s;\n                width:120px;\n                height:80px;\n                margin-right:50px;\n\n\n\n\n                span {\n                    font-size:25px;\n                    p {\n                        color:white;\n                        font-size: 16px;\n                        text-align: center;\n                        font-weight: 400;\n                    }\n                }\n\n\n                div {\n                    display:flex;\n                    flex-direction: column;\n                    justify-content: center;\n                }\n             }\n\n             .share-instead:hover {\n                background-color: $theme-contrast;\n\n                span {\n                    color:white;\n                }\n             }\n\n            .material-symbols-outlined {\n                font-size:50px;\n            }\n        }\n\n       .radio-selector-container {\n        p {\n            margin:0 0 10 0;\n            font-size: 13pt;\n        }\n        display:flex;\n        flex-direction: column;\n        justify-content: space-around;\n        border: 1px solid rgba($theme-lightgray, 0.3);\n\n        height:fit-content;\n        padding: 0 0 10px 0;\n        border-radius:5px;\n\n            .radioinput {\n                accent-color: $theme-main;\n                margin-bottom:5px;\n\n            }\n            label {\n                font-size: 11pt;\n\n            }\n       }\n\n        .radio-selector-container-no-border {\n        p {\n            margin:0 0 10 0;\n            font-size: 13pt;\n        }\n        display:flex;\n        flex-direction: column;\n        justify-content: space-around;\n\n        height:fit-content;\n        padding: 10px 0 10px 0;\n        border-radius:5px;\n\n            .radioinput {\n                accent-color: $theme-main;\n                margin-bottom:5px;\n\n            }\n            label {\n                font-size: 11pt;\n\n            }\n       }\n\n       .custom-selectors-container {\n        display:flex;\n        flex-direction: column;\n        justify-content: space-between;\n\n        border: 1px solid rgba($theme-lightgray, 0.3);\n\n        height:fit-content;\n        padding: 10px 10% 10px 10%;\n        border-radius:5px;\n\n            div {\n                margin: inherit;\n                display:flex;\n                // flex-direction: row;\n                justify-content: space-between;\n\n                select{\n                    width:158px;\n                    background-color: white;\n                    border: 1px solid #8f8f9d;\n\n                    font-family: Arial, Helvetica, sans-serif;\n                    text-align: center;\n\n                }\n\n            }\n\n       }\n\n       .result-container {\n        display:flex;\n        flex-direction: row;\n        justify-content: space-between;\n       }\n\n\n    }\n\n    .download-footer {\n        width:100%;\n        height:10%;\n\n        display:flex;\n        flex-direction: row;\n        justify-content: space-between;\n        padding: 10px;\n        span {\n            width:fit-content;\n            height:fit-content;\n            padding: 5px 10px 5px 10px;\n            background-color: $theme-main;\n\n            border-radius: 10px;\n            display:flex;\n            justify-content: center;\n\n            cursor:pointer;\n\n            p {\n                font-size: 12pt;\n                margin:0;\n                color: white;\n            }\n            &.disabled {\n            background-color: gray; // Grey out background\n            cursor: not-allowed; // Change cursor to indicate it's not clickable\n            opacity: 0.6; // Make it slightly transparent\n            pointer-events: none; // Prevent any click events\n        }\n        }\n\n        div :hover {\n            background-color: $theme-contrast;\n        }\n    }\n\n    mat-tab {\n        margin-top: 50px;\n    }\n}\n\n\n.plot {\n    height:500px;\n    overflow:hidden;\n}\n\n.dialog {\n    display:none;\n    //height:510px;\n    //width:585px;\n    z-index: 5;\n    //margin-left:-10px;\n    //margin-top:-10px;\n    position:absolute;\n    height:75vh;\n\n    width:100%;\n    max-width: 80vw;\n    //border-radius:10px;\n\n}\n\n\napp-chart-share-dialog {\n    width:100vw;\n}\n\n.rounded-button-filled {\n    background-color: $theme-accent; /* Button background color */\n    color: white;           /* Text color */\n    border: 2px solid $theme-accent;      /* No border */\n    border-radius: 5px;   /* Rounded corners */\n    padding: 10px 20px;    /* Padding for button size */\n    margin-left: 10px;     /* Spacing between buttons */\n    margin-bottom: 30px;   /* Bottom margin */\n    // font-size: 16px;       /* Font size */\n    cursor: pointer;       /* Pointer on hover */\n    transition: background-color 0.3s; /* Smooth transition on hover */\n}\n\n.rounded-button-filled:hover {\n    background-color: #fff; /* Change color on hover */\n    color: $theme-accent;\n}\n\n.rounded-button-inverse {\n    background-color: #fff; /* Transparent background */\n    color: $theme-main;                   /* Text color matching filled button */\n    border: 2px solid $theme-accent;        /* Pink border */\n    border-radius: 5px;           /* Rounded corners */\n    padding: 10px 20px;           /* Padding for button size */\n    margin-left: 10px;            /* Spacing between buttons */\n    // font-size: 16px;              /* Font size */\n    cursor: pointer;               /* Pointer on hover */\n    transition: background-color 0.3s, color 0.3s; /* Smooth transition on hover */\n}\n\n.rounded-button-inverse:hover {\n    background-color: $theme-accent;       /* Background color on hover */\n    color: white;                 /* Text color on hover */\n}\n\n.error-message{\n    color: red;\n}\n\n\n.filter-list-input{\n    margin-top: 15px;\n    width: 95%;\n}\n\n\n\n\n.lock{\n   font-size: 12px;\n\n}\n\n\n a{\n    width:100%;\n    height:100%;\n    color:$theme-main;\n    text-decoration: none;\n    display:flex;\n\n}\n.buttons-disabled{\n    color: $theme-source;\n\n}\n.padlock-container{\n    display:flex;\n\n}\n@media (max-width:767px) {\n    ::ng-deep .mat-mdc-tab .mdc-tab__content {\n    font-size: 9pt; /* Set your desired font size here */\n    }\n\n    .download-dialog {\n        width:300px;\n\n        .download-header p {\n            font-size: 18px;\n\n        }\n    }\n\n    .chart-container {\n        min-width: 80vw;\n        //max-width:85vw;\n    }\n}\n","@import \"variables\";\r\n\r\n$sb-text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);\r\n$sb-text-size: 0.8em;\r\n\r\n.sb-circles-dark, .sb-circles-light {\r\n  .sb-wrapper {\r\n    --sb-color: #{$sb-accent};\r\n    --sb-background: transparent;\r\n    --sb-min-width: fit-content;\r\n    --sb-height: fit-content;\r\n    --sb-icon-size: 1.4em;\r\n\r\n    &:active {\r\n      .sb-icon {\r\n        box-shadow: 0 7px 8px -4px rgba(0, 0, 0, .2), 0 12px 17px 2px rgba(0, 0, 0, .14), 0 5px 22px 4px rgba(0, 0, 0, .12);\r\n      }\r\n    }\r\n\r\n    .sb-icon {\r\n      background-color: var(--button-color);\r\n      box-shadow: 0 3px 5px -1px rgba(0, 0, 0, .2), 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12);\r\n      width: 2.5em;\r\n      min-height: 2.5em;\r\n      border-radius: 50%;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-text {\r\n      color: var(--button-color);\r\n      font-size: $sb-text-size;\r\n      margin-top: 5px;\r\n      border-radius: 1em;\r\n      width: 100%;\r\n      height: 1.8em;\r\n      line-height: 1.8em;\r\n      padding: 0;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-content {\r\n      align-items: center;\r\n      flex-direction: column;\r\n    }\r\n  }\r\n}\r\n\r\n.sb-circles-dark .sb-wrapper {\r\n\r\n  .sb-icon {\r\n    background-color: var(--button-color);\r\n  }\r\n\r\n  .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n}\r\n\r\n.sb-circles-light .sb-wrapper {\r\n\r\n  .sb-icon, .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n\r\n  .sb-icon {\r\n    background: radial-gradient(ellipse farthest-corner at center, white 30%, darken(white, 5%) 100%);\r\n  }\r\n}\r\n","\n@import \"../node_modules/ngx-sharebuttons/themes/default.scss\";\n@import \"../node_modules/ngx-sharebuttons/themes/circles.scss\";\n\n/* You can add global styles to this file, and also import other style files */\n\nbody, html {\nheight: 100vh;\n// width: 100vh;\nmargin: 0;\n}\n\nbody {\n    font-family: Arial, sans-serif;\n    height: 100vh;\n    background-color: #fff; /* Background color for the top half */\n    position: relative;\n    display: block;\n    justify-content: center;\n    align-items: center;\n    }\n\n\nbody::after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 50%;\n    background: #fff;\n\n\n    z-index: -1; /* Ensure the gradient is behind other content */\n}\n\n\n$theme-back: #2D2D2A;\n/* Old palette\n$theme-main: #B05995;\n$theme-contrast: #3792BF;\n$theme-1: #282B59;\n$theme-2: #D683DD;\n$theme-3: #27567A;\n$theme-4: #44DDC4;\n$theme-5: #3336AE;\n$theme-6: #18C43D;\n*/\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$theme-primary: #3792BF;\n$theme-secondary: #1B3E78;\n$theme-color3: #AACCFF;\n$theme-color4: #BDBDBD;\n$theme-color5: #7D7979;\n$theme-accent: #0CAD99;\n$text-gray:#787c95;\n$theme-red:#d9534f;\n\n$theme-back-light: #4c4c47;\n$theme-lightgray: #e7e7e7;\n$theme-gray-text: #787476;\n\n$theme-table-header: #f6f6f6;\n$theme-table-body:#f8f8f8;\n$theme-source:#9E9E9E;\n\n\n$value-chain-1: #44DDC4;\n$value-chain-2: \"\";\n$value-chain-3: \"\";\n$value-chain-4: \"\";\n\n.material-symbols-outlined {\n\n    cursor: pointer;\n    font-variation-settings:\n        'FILL' 0,\n        'wght' 400,\n        'GRAD' 0,\n        'opsz' 48;\n}\n\np {\n    font-family:Arial, Helvetica, sans-serif;\n    text-align: justify;\n    color: $theme-back;\n}\n\n\n\nhtml, body { height: 100%; }\nbody { margin: 0; font-family: Roboto, \"Helvetica Neue\", sans-serif; }\n\n\n.generic-button, .generic-button-alt {\n  color: white;\n  border-radius: 5px;   /* Rounded corners */\n    padding: 10px 20px;    /* Padding for button size */\n    margin-right: 10px;\n\n    // font-size: 16px;       /* Font size */\n    cursor: pointer;       /* Pointer on hover */\n    transition: background-color 0.3s; /* Smooth transition on hover */\n\n    p {\n        color:white;\n        margin:0;\n    }\n}\n.generic-button {\n  background-color: $theme-main; /* Button background color */\n  border: 2px solid $theme-main;      /* No border */\n}\n\n.generic-button-alt {\n  background-color: $theme-accent; /* Button background color */\n  border: 2px solid $theme-accent;      /* No border */\n}\n\n.generic-button:hover {\n    background-color: #fff; /* Change color on hover */\n    color: $theme-main;\n\n    p {\n        color: $theme-main\n    }\n}\n\n.generic-button-alt:hover {\n  background-color: #fff; /* Change color on hover */\n  color: $theme-accent;\n\n  p {\n    color: $theme-accent\n  }\n}\n\n.generic-button:disabled, .generic-button-alt:disabled {\n    background-color: $theme-lightgray;\n    border-color: $theme-lightgray;\n    cursor:not-allowed;\n\n}\n","@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-Black.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-Bold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-Medium.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Regular.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-Light.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLight.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-Thin.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-BlackItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-BoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-MediumItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Italic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-LightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-ThinItalic.ttf');\n}\n\n","@import \"fonts\";\n\n// this file is more for variables that cannot be used in the theme\n// many of these should be migrated after the material theme has been configured.\n\n$font-family: \"Dm Sans\", sans-serif;\n\n/* Old palette\n$accent-btn: #DD7EB0;\n$dark-text: #303f71;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #84D9FD;*/\n\n$accent-btn: #0CAD99;\n$dark-text: #1B3E78;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #3792BF;\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$app-background: #F4F7FE;\n\n$rDNA-success: #00B300;\n$rDNA-alert: #FF0000;\n$rDNA-neutral: #FFBF00;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
